<template>
	<div>
		<template v-if="items.length">
			<div
				v-for="item in items"
				:key="item.key"
				class="d-flex my-3"
			>
				<span :class="[`${textClass}-regular`, 'text-textSecondary700 w-50']">{{ item.key }}</span>
				<span
					v-if="typeof item.text === 'string'"
					:class="[`${textClass}-medium`, 'text text-textBody w-50']"
				>
					{{ item.text }}
				</span>
				<template v-else>
					<span
						v-for="text in item.text"
						:class="[`${textClass}-medium`, 'text text-textBody flex-grow-1']"
					>
						{{ text }}
					</span>
				</template>
			</div>
		</template>
		<div
			v-else
			class="ao-text-800 ao-p2-medium ml-2"
		>
			{{ $t('No data') }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'PassportList',

	props: {
		items: {
			type: Array,
		},
		size: {
			type: String,
			default: 'medium',
		},
	},

	computed: {
		textClass() {
			const sizes = {
				large: 'ao-p2',
				medium: 'ao-p3',
				small: 'ao-p4',
			}

			return sizes[this.size]
		},
	},
}
</script>
